import type { IconSvgObject } from './types';

const ScreenAddToHome02Icon: IconSvgObject = [
  ["path", { d: "M6 9H11V14M10.5 9.5L4 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 17V20.5C7 21.3284 7.67157 22 8.5 22H18.5C19.3284 22 20 21.3284 20 20.5V3.5C20 2.67157 19.3284 2 18.5 2H8.5C7.67157 2 7 2.67157 7 3.5V6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15.5 2H11.5L12 3H15L15.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ScreenAddToHome02Icon;
